var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconXCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 35.5,
    height: 35.5,
    rx: 17.75,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0073 9.67969H22.0024C24.7375 9.67969 26.569 11.5999 26.569 14.4561V21.0486C26.569 23.8966 24.7375 25.8161 22.0024 25.8161H15.0073C12.2722 25.8161 10.4326 23.8966 10.4326 21.0486V14.4561C10.4326 11.5999 12.2722 9.67969 15.0073 9.67969ZM20.929 20.168C21.2033 19.8945 21.2033 19.4507 20.929 19.1764L19.4929 17.7403L20.929 16.3033C21.2033 16.0298 21.2033 15.578 20.929 15.3037C20.6547 15.0286 20.2109 15.0286 19.9286 15.3037L18.5005 16.739L17.0643 15.3037C16.782 15.0286 16.3382 15.0286 16.0639 15.3037C15.7896 15.578 15.7896 16.0298 16.0639 16.3033L17.5 17.7403L16.0639 19.1683C15.7896 19.4507 15.7896 19.8945 16.0639 20.168C16.2011 20.3052 16.3866 20.3786 16.5641 20.3786C16.7497 20.3786 16.9272 20.3052 17.0643 20.168L18.5005 18.7407L19.9366 20.168C20.0738 20.314 20.2513 20.3786 20.4288 20.3786C20.6143 20.3786 20.7918 20.3052 20.929 20.168Z",
    fill: "#FF0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXCircle);
export default __webpack_public_path__ + "static/media/icon-x-circle.ba405db5889e6a12a40747c08f8dee4c.svg";
export { ForwardRef as ReactComponent };